import type {DomAndDmContext} from '../../types'

export const executeWithRenderAndHistory = async (
    dmContext: DomAndDmContext,
    task: () => Promise<void>
): Promise<void> => {
    const {
        documentServices,
        soq,
        documentManager: {dal},
        viewerManager: {viewerSiteAPI}
    } = dmContext

    await task()

    dal.commitTransaction()
    await viewerSiteAPI.waitForViewer()
    soq.triggerSiteUpdated()
    documentServices.history.add('dsAdapterDebug trigger', {
        isAddingComponent: true, // will cause editor to deselect,
        currentPage: documentServices.pages.getCurrentPageId()
    })
}
